import React, { useEffect, useState } from 'react';

const LoadingOverlay = () => {
    const icons = ["pi pi-money-bill", "pi pi-wallet", "pi pi-file", "pi pi-check-square"];
    const [currentIconIndex, setCurrentIconIndex] = useState(0);
    const loadingText = "Yükleniyor...";
    const [charIndices, setCharIndices] = useState([]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIconIndex((prev) => (prev + 1) % icons.length);
        }, 1400);
        return () => clearInterval(interval);
    }, [icons.length]);

    useEffect(() => {
        setCharIndices(Array(loadingText.length).fill(0));

        let currentCharIndex = 0;
        const waveInterval = setInterval(() => {
            setCharIndices(prev => {
                const newIndices = [...prev].fill(0);
                newIndices[currentCharIndex] = 1;
                return newIndices;
            });

            currentCharIndex = (currentCharIndex + 1) % loadingText.length;
        }, 100);

        return () => clearInterval(waveInterval);
    }, [loadingText.length]);

    useEffect(() => {
        const styles = `
      @keyframes cylinder {
        0% { transform: rotateY(0deg); }
        100% { transform: rotateY(-360deg); }
      }

      .animate-cylinder {
        animation: cylinder 6s linear infinite;
      }
      .perspective-500 {
        perspective: 500px;
      }
      
      .wave-char {
        display: inline-block;
        transition: transform 0.1s ease-in-out;
      }
      
      .wave-char.active {
        transform: translateY(-5px);
        font-weight: bold;
      }
      
      .wave-space {
        display: inline-block;
        width: 0.5em;
      }

      @media (max-width: 640px) {
        .wave-char.active {
          transform: translateY(-3px);
        }
      }
    `;

        const styleSheet = document.createElement("style");
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, []);

    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm">
            <div className="w-[220px] sm:w-[300px] h-[150px] sm:h-[200px] flex items-center justify-center perspective-500">
                <div
                    className="w-full h-full animate-cylinder"
                    style={{
                        transformStyle: "preserve-3d",
                        position: "relative",
                    }}
                >
                    {icons.map((icon, index) => {
                        const angle = (index * 360) / icons.length;
                        const isActive = index === currentIconIndex;

                        return (
                            <i
                                key={index}
                                className={icon}
                                style={{
                                    color: "#ffffff",
                                    fontSize: isActive ? "calc(2rem + 3vmin)" : "calc(1rem + 2vmin)", // Responsive font size
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: `translate(-50%, -50%) rotateY(${angle}deg) translateZ(80px)`, // Reduced Z for mobile
                                    opacity: isActive ? 1 : 0.3,
                                    transition: "font-size 0.3s ease, opacity 0.3s ease",
                                }}
                            ></i>
                        );
                    })}
                </div>
            </div>

            <div className="mt-6 sm:mt-8 text-base sm:text-xl md:text-3xl text-center font-medium text-white px-4  max-w-[90vw]">
                {loadingText.split('').map((char, index) => {
                    if (char === ' ') {
                        return <span key={index} className="wave-space"></span>;
                    }
                    return (
                        <span
                            key={index}
                            className={`wave-char ${charIndices[index] === 1 ? 'active' : ''}`}
                            style={{
                                color: charIndices[index] === 1 ? "#ffffff" : "#cccccc"
                            }}
                        >
                            {char}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default LoadingOverlay;